import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert as RSAlert,
} from "reactstrap";
import Alert from "react-s-alert-v3";
import _ from "lodash";
import { constants } from "../utils";
import Select from "react-select";
import { ui_helpers } from "../helpers";
import Card from "@repay/react-credit-card";

const defaultPaymentData = (d) => {
  return {
    creditCardType: "", // d.creditCardType,
    ccNumber: "", // d.ccNumber,
    ccExpiryMonth: "", // d.ccExpiryMonth,
    ccExpiryYear: "", // d.ccExpiryYear,
    ccFullName: "", // d.ccFullName,
    achRoutingNo: "", // d.achRoutingNo,
    achAccountNo: "", // d.achAccountNo,
    achFullName: "", // d.achFullName,
    achAccountType: constants.BANKING_ACCOUNT_TYPES[0].value,
    achBankName: "",
    achEntryClass: constants.BANKING_ACCOUNT_TYPES[0].entryClass,
    achType: "ACHDebit",
  };
};

const PAYMENT_METHODS = [
  { label: "Credit Card", value: constants.PAYMENT_TYPE_IDS.CREDIT_CARD },
  { label: "ACH", value: constants.PAYMENT_TYPE_IDS.ACH_DEBIT },
];

export default function PaymentInformationModal({
  onSetPaymentData,
  onCancel,
  creditCardOrAch,
  setCreditCardOrAch,
  contractType,
  confirmTransfer,
  setConfirmTransfer,
}) {
  const [paymentData, setPaymentData] = useState(defaultPaymentData());
  const [cardZip, setCardZip] = useState("");
  const [cardNo, setCardNo] = useState("");
  const [cardMMYY, setCardMMYY] = useState("");
  const [cardCVC, setCardCVC] = useState("");
  const [manualCard, setManualCard] = useState(null);

  useEffect(() => {
    // if (contractType === constants.CONTRACT_TYPE.CASH_SALE) {
    // NOTE: All transfers are now ACH by request.
      setCreditCardOrAch(
        _.find(PAYMENT_METHODS, (x) => x.value === constants.PAYMENT_TYPE_IDS.ACH_DEBIT)
      );
    // }
  }, []);

  function onChange(value, fieldName) {
    let newData = {
      ...paymentData,
      [fieldName]: value,
    };
    if (fieldName === "achAccountType") {
      const selected = _.find(constants.BANKING_ACCOUNT_TYPES, (a) => a.value === value);
      if (selected) {
        newData.achEntryClass = selected.entryClass;
      }
    }
    setPaymentData(newData);
  }

  function onVerifyCard() {
    const parsed = ui_helpers.parseManualCardInformation(cardZip, cardNo, cardMMYY, cardCVC);
    if (!parsed.ErrorMessage) {
      setManualCard(parsed);
      setPaymentData(parsed);
    }
  }

  function onCommit() {
    if (!creditCardOrAch || !creditCardOrAch?.value) {
      Alert.warning("Select a payment method.");
      return;
    }
    if (creditCardOrAch.value === constants.PAYMENT_TYPE_IDS.CREDIT_CARD) {
      if (!manualCard || manualCard.ErrorMessage) {
        Alert.warning("Please verify and provide valid card information.");
        return;
      }
    } else if (creditCardOrAch.value === constants.PAYMENT_TYPE_IDS.ACH_DEBIT) {
      if (_.trim(paymentData.achRoutingNo).length < 4) {
        Alert.warning("Enter a valid routing number.");
        return;
      }
      if (_.trim(paymentData.achAccountNo).length < 4) {
        Alert.warning("Enter a valid account number.");
        return;
      }
      if (_.trim(paymentData.achFullName).length < 4) {
        Alert.warning("Enter a valid account holder name.");
        return;
      }
      if (_.trim(paymentData.achBankName).length < 4) {
        Alert.warning("Enter a valid bank name.");
        return;
      }
    } else {
      Alert.warning("Select a payment method.");
      return;
    }

    if (onSetPaymentData) {
      onSetPaymentData(paymentData);
    }
  }

  return (
    <Modal isOpen={true} centered className="modal-lg">
      <ModalHeader>Enter Payment Information</ModalHeader>
      <ModalBody>
        <Form id="payment-form" className="form-horizontal">
          <div
            style={{
              backgroundColor: "#E5E5FF",
              borderRadius: "4px",
              padding: "4px",
              fontSize: "0.85rem",
              marginBottom: "10px",
            }}
          >
            <div style={{ fontWeight: "bold", fontSize: "16px" }}>AUTHORIZATION</div>
            <div>I authorize the charge or charges to my account as outlined in this form.</div>
          </div>
          {creditCardOrAch === null ? (
            <Row className="mb-1">
              <Col sm="3">
                <label className="control-label">Payment Method</label>
              </Col>
              <Col sm="9">
                <Select
                  options={PAYMENT_METHODS}
                  value={creditCardOrAch}
                  onChange={(x) => setCreditCardOrAch(x)}
                />
              </Col>
            </Row>
          ) : creditCardOrAch.value === constants.PAYMENT_TYPE_IDS.CREDIT_CARD && contractType !== constants.CONTRACT_TYPE.CASH_SALE ? (
            <>
              <Card cvc={cardCVC} number={cardNo} expiration={cardMMYY} focused={"name"} />
              <Row className="mt-3 mb-1">
                <Col xs="5">
                  <Input
                    type="text"
                    bsSize="sm"
                    value={cardNo}
                    maxLength="20"
                    placeholder="Card number"
                    onChange={(e) => setCardNo(e.target.value)}
                  />
                </Col>
                <Col xs="3">
                  <Input
                    type="text"
                    bsSize="sm"
                    value={cardZip}
                    maxLength="12"
                    placeholder="Zip Code"
                    onChange={(e) => setCardZip(e.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="5">
                  <Input
                    type="text"
                    bsSize="sm"
                    value={cardMMYY}
                    maxLength="4"
                    placeholder="MMYY"
                    onChange={(e) => setCardMMYY(e.target.value)}
                  />
                </Col>
                <Col xs="3">
                  <Input
                    type="text"
                    bsSize="sm"
                    value={cardCVC}
                    maxLength="5"
                    placeholder="CVC"
                    onChange={(e) => setCardCVC(e.target.value)}
                  />
                </Col>
              </Row>
              {manualCard ? (
                <div className="mt-2">
                  {manualCard.ErrorMessage ? (
                    <RSAlert color="warning" className="mb-0">
                      {manualCard.ErrorMessage}
                    </RSAlert>
                  ) : (
                    <RSAlert color="success" className="mb-0">
                      The provided card information is valid.
                    </RSAlert>
                  )}
                </div>
              ) : null}
              <Button color="warning" className="text-light mt-2" onClick={onVerifyCard}>
                Verify Card Information
              </Button>
            </>
          ) : // <>
          //   <Row className="mb-1">
          //     <Col sm="3">
          //       <label className="control-label">Credit Card</label>
          //     </Col>
          //     <Col sm="9">
          //       <div style={{ width: "60%", fontSize: "0.9rem" }}>
          //         <Select
          //           options={constants.CREDIT_CARD_TYPES}
          //           value={paymentData.creditCardType}
          //           onChange={(x) => onChange(x, "creditCardType")}
          //         />
          //       </div>
          //       <div className="mt-1">
          //         <Input
          //           type="text"
          //           bsSize="sm"
          //           value={paymentData.ccNumber}
          //           maxLength="20"
          //           style={{ width: "200px", marginLeft: "0", float: "left" }}
          //           placeholder="Card Number"
          //           onChange={(e) => onChange(e.target.value, "ccNumber")}
          //         />
          //         <span
          //           style={{
          //             float: "left",
          //             padding: "10px 2px 4px 2px",
          //             fontSize: "0.9rem",
          //           }}
          //         >
          //           expires
          //         </span>
          //         <Input
          //           type="text"
          //           bsSize="sm"
          //           value={paymentData.ccExpiryMonth}
          //           maxLength="2"
          //           style={{ width: "40px", float: "left" }}
          //           placeholder="MM"
          //           onChange={(e) => onChange(e.target.value, "ccExpiryMonth")}
          //         />
          //         <Input
          //           type="text"
          //           bsSize="sm"
          //           value={paymentData.ccExpiryYear}
          //           maxLength="4"
          //           style={{ width: "60px", marginLeft: "1px", float: "left" }}
          //           placeholder="YYYY"
          //           onChange={(e) => onChange(e.target.value, "ccExpiryYear")}
          //         />
          //         <br />
          //         <Input
          //           type="text"
          //           bsSize="sm"
          //           value={paymentData.ccFullName}
          //           maxLength="70"
          //           style={{ float: "left" }}
          //           placeholder="Cardholder Full Name"
          //           onChange={(e) => onChange(e.target.value, "ccFullName")}
          //         />
          //       </div>
          //     </Col>
          //   </Row>
          // </>
          constants.PAYMENT_TYPE_IDS.ACH_DEBIT ? (
            <>
              <Row className="mb-1">
                <Col sm="3">
                  <label className="control-label">ACH</label>
                </Col>
                <Col sm="9">
                  <Input
                    type="text"
                    bsSize="sm"
                    value={paymentData.achRoutingNo}
                    maxLength="9"
                    style={{ marginBottom: "2px", float: "left" }}
                    placeholder="Routing Number"
                    onChange={(e) => onChange(e.target.value, "achRoutingNo")}
                  />
                  <Input
                    type="text"
                    bsSize="sm"
                    value={paymentData.achAccountNo}
                    maxLength="17"
                    style={{ marginBottom: "2px", float: "left" }}
                    placeholder="Account Number"
                    onChange={(e) => onChange(e.target.value, "achAccountNo")}
                  />
                  <Input
                    type="text"
                    bsSize="sm"
                    value={paymentData.achFullName}
                    maxLength="70"
                    style={{ float: "left" }}
                    placeholder="Account Holder Full Name"
                    onChange={(e) => onChange(e.target.value, "achFullName")}
                  />
                </Col>
              </Row>
              <Row className="mb-1">
                <Col sm="3">
                  <label className="control-label">Account Type</label>
                </Col>
                <Col sm="9">
                  <Select
                    options={constants.BANKING_ACCOUNT_TYPES}
                    onChange={(option) => {
                      onChange(option.value, "achAccountType");
                    }}
                    value={_.find(
                      constants.BANKING_ACCOUNT_TYPES,
                      (a) => a.value === paymentData.achAccountType
                    )}
                  />
                </Col>
              </Row>
              <Row className="mb-1">
                <Col sm={{ size: 9, offset: 3 }}>
                  <Input
                    type="text"
                    placeholder="Bank Name"
                    bsSize="sm"
                    value={paymentData.achBankName}
                    maxLength="70"
                    onChange={(e) => onChange(e.target.value, "achBankName")}
                  />
                </Col>
              </Row>
            </>
          ) : null}
        </Form>
        <div className="d-flex flex-column mt-3">
          <p><strong>
            This transfer option is for business accounts only. Payment details will be saved for future use. If you do not want to store payment information, please make a direct payment instead.
          </strong></p>
          <div className="d-flex align-items-center">
            <Input
              type="checkbox"
              checked={confirmTransfer}
              onChange={(e) => setConfirmTransfer(e.target.checked)}
              required
              style={{ minWidth: "1.2em" }}
            />
            <p className="mb-0 ms-2">
            By checking this box, I confirm the account number belongs to my sales lot, I am authorized to initiate debits, and this account will be used for payment transfers to the associated company (RTO Provider or Manufacturer).
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col className="d-flex flex-row justify-content-end">
            <Col className="d-flex justify-content-end">
              <Button color="secondary" onClick={onCancel}>
                Cancel
              </Button>
            </Col>
            <Col className="ms-1 d-flex justify-content-end">
              <Button
                color="primary"
                className="float-end"
                onClick={onCommit}
                disabled={!confirmTransfer || (
                  creditCardOrAch?.value === constants.PAYMENT_TYPE_IDS.CREDIT_CARD &&
                  (!manualCard || manualCard.ErrorMessage))
                }
              >
                Save
              </Button>
            </Col>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
}
